
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PackingListSelector } from '@/components/packing/PackingListSelector';
import { PackingListEditor } from '@/components/packing/PackingListEditor';
import { useIsMobile } from '@/hooks/use-mobile';

interface BlogPackingTabProps {
  blogPostId: string;
  selectedPackingListId?: string;
  onSelect: (id?: string) => void;
}

export function BlogPackingTab({ 
  blogPostId, 
  selectedPackingListId, 
  onSelect 
}: BlogPackingTabProps) {
  const isMobile = useIsMobile();
  
  return (
    <Card className="glass-card">
      <CardHeader className={isMobile ? "px-4 py-4" : ""}>
        <CardTitle>What to Pack</CardTitle>
        <CardDescription>
          Add a packing list with recommendations
        </CardDescription>
      </CardHeader>
      <CardContent className={`space-y-4 ${isMobile ? "px-4 pb-4" : ""}`}>
        <div className="space-y-2">
          <Label>Select a Packing List</Label>
          <p className="text-sm text-muted-foreground mb-2">
            You can select an existing packing list or create a new one after saving the blog post.
          </p>
          <PackingListSelector
            blogPostId={blogPostId}
            selectedPackingListId={selectedPackingListId}
            onSelect={onSelect}
          />
        </div>
        
        {selectedPackingListId && (
          <div className="pt-4 border-t">
            <PackingListEditor existingPackingListId={selectedPackingListId} />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
